import { render, staticRenderFns } from "./formCategories.vue?vue&type=template&id=0707f67f&scoped=true&"
import script from "./formCategories.vue?vue&type=script&lang=js&"
export * from "./formCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707f67f",
  null
  
)

export default component.exports